<template>
    <div class="bodyApp" style="background:#0D033F">
        <div class="f_img">
            <img src="@/assets/haoka/5.jpg" alt="" style="margin-bottom:17px;margin-top:13px;width:100%;">
        </div>
        <div class="from_data">
            <div class="f_data" id="formData">
                <div class="f_title">限时免费领取入口</div>
                <van-swipe class="my-swipe" :autoplay="5000" vertical :loop="true" :height="36" :show-indicators="false">
                    <van-swipe-item>曾** 已领取 1分钟前 <span>已有18379人申请</span></van-swipe-item>
                    <van-swipe-item>李** 正在领取 1分钟前    <span>已有18379人申请</span></van-swipe-item>
                    <van-swipe-item>张** 已领取 1分钟前    <span>已有18379人申请</span></van-swipe-item>
                    <van-swipe-item>赵** 已领取 1分钟前    <span>已有18379人申请</span></van-swipe-item>
                    <van-swipe-item>钱** 正在领取 1分钟前    <span>已有18379人申请</span></van-swipe-item>
                    <van-swipe-item>孙** 已领取 1分钟前      <span>已有18379人申请</span></van-swipe-item>
                </van-swipe>
                <van-cell-group>
                    <van-field  v-model="dataFrom.takeNickname"  clearable  label="姓名" placeholder="请输入姓名（已加密）"  />
                    <van-field v-model="dataFrom.takePhone"  maxlength="11" clearable label="联系号码" placeholder="请输入联系号码（已加密）" />
                    <!-- <van-field v-model="dataFrom.idCard"  maxlength="28" clearable label="身份证号" placeholder="请输入入网身份证号（已加密）" /> -->
                    <van-field v-model="dataFrom.pcaAddress" clearable label="省市区" placeholder="请选择省市区" readonly @focus="showAddressVisible()"/>
                    <van-field v-model="dataFrom.takeAddress" clearable label="详细地址" placeholder="请输入详细地址" />
                     <van-field v-if="dataFrom.takeAddress.length>2" v-model="dataFrom.idCard"  maxlength="28" clearable label="身份证号" placeholder="请输入入网身份证号（已加密）" />
                </van-cell-group> 
                <van-popup v-model="dataFrom.addressVisible" position="bottom">
            <van-area
                :area-list="areaList"
                :columns-placeholder="['请选择', '请选择', '请选择']"
                @cancel="cancelSelectAddress()"
                @confirm="selectAddress"
            />
        </van-popup>
                <div class="checkbox-info">
                    <van-row>
                        <van-col :span="2" style="text-align:center;">
                            <van-checkbox v-model="checked"></van-checkbox> 
                        </van-col>
                        <van-col :span="22" style="font-size:14px;">
                            <span >我已阅读并同意</span>
                            <span  style="color:#FF5700;line-height:26px;" @click="aaaa()">《用户入网协议》</span>
                             <span  style="color:#FF5700;line-height:26px;" @click="cccc()">《开户服务协议与防范提示告知书》</span>
                            <span>和</span>
                            <span style="color:#FF5700;cursor: pointer;"  @click="bbbb()">《电子渠道商品销售服务协议与解约条款》</span>
                        </van-col>
                    </van-row>
                </div>
                 <p style="text-align: center; color:red">客服咨询微信：LCR-627</p>
                <van-button round type="info" class="btnButton" @click="sunmbitFn()">0元申请 包邮到家</van-button>
            </div>
        </div>
        <div class="f-swige">
            <div class="f_new">热门评论</div>
            <van-swipe class="my-swipe"  vertical :autoplay="5000" :loop="true" :height="70" :show-indicators="false">
                <van-swipe-item><div class="jusaf">
                    <van-row>
                        <van-col span="4">
                            <img src="@/assets/stage/icon17.png" alt=""/> 
                        </van-col>
                        <van-col span="20">
                            <div style="color:#000;height:20px;line-height: 20px;">
                                <van-row>
                                    <van-col span="12"> 盈**牛 </van-col>
                                    <van-col span="12" style="text-align:right;color:#999;">234</van-col>
                                </van-row>
                            </div>
                            <div style="color: rgb(153, 153, 153);line-height: 20px;">网速杠杠的，费用美美的</div>
                        </van-col>
                    </van-row>
                </div></van-swipe-item>
                <van-swipe-item><div class="jusaf">
                        <van-row>
                        <van-col span="4">
                            <img src="@/assets/stage/icon17.png" alt=""/> 
                        </van-col>
                        <van-col span="20">
                            <div style="color:#000;height:20px;line-height: 20px;">
                                <van-row>
                                    <van-col span="12">罗**</van-col>
                                    <van-col span="12" style="text-align:right;color:#999;">234</van-col>
                                </van-row>
                            </div>
                            <div style="color: rgb(153, 153, 153);line-height: 20px;">还便宜，网速还很快</div>
                        </van-col>
                    </van-row>
                </div></van-swipe-item>
                <van-swipe-item><div class="jusaf">
                        <van-row>
                        <van-col span="4">
                            <img src="@/assets/stage/icon17.png" alt=""/> 
                        </van-col>
                        <van-col span="20">
                            <div style="color:#000;height:20px;line-height: 20px;">
                                <van-row>
                                    <van-col span="12">离**歌</van-col>
                                    <van-col span="12" style="text-align:right;color:#999;">234</van-col>
                                </van-row>
                            </div>
                            <div style="color: rgb(153, 153, 153);line-height: 20px;">不错......很划算</div>
                        </van-col>
                    </van-row>
                </div></van-swipe-item>
                <van-swipe-item><div class="jusaf">
                        <van-row>
                        <van-col span="4">
                            <img src="@/assets/stage/icon17.png" alt=""/> 
                        </van-col>
                        <van-col span="20">
                            <div style="color:#000;height:20px;line-height: 20px;">
                                <van-row>
                                    <van-col span="12">辣**果</van-col>
                                    <van-col span="12" style="text-align:right;color:#999;">234</van-col>
                                </van-row>
                            </div>
                            <div style="color: rgb(153, 153, 153);line-height: 20px;">好实惠的手机套餐，经济适用。</div>
                        </van-col>
                    </van-row>
                </div></van-swipe-item>
                <van-swipe-item><div class="jusaf">
                        <van-row>
                        <van-col span="4">
                            <img src="@/assets/stage/icon17.png" alt=""/> 
                        </van-col>
                        <van-col span="20">
                            <div style="color:#000;height:20px;line-height: 20px;">
                                <van-row>
                                    <van-col span="12">王**森</van-col>
                                    <van-col span="12" style="text-align:right;color:#999;">234</van-col>
                                </van-row>
                            </div>
                            <div style="color: rgb(153, 153, 153);line-height: 20px;">手机卡到的很快,激活顺利,套餐价格优惠,满意.</div>
                        </van-col>
                    </van-row>
                </div></van-swipe-item>
                <van-swipe-item><div class="jusaf">
                        <van-row>
                        <van-col span="4">
                            <img src="@/assets/stage/icon17.png" alt=""/> 
                        </van-col>
                        <van-col span="20">
                            <div style="color:#000;height:20px;line-height: 20px;">
                                <van-row>
                                    <van-col span="12">严**</van-col>
                                    <van-col span="12" style="text-align:right;color:#999;">234</van-col>
                                </van-row>
                            </div>
                            <div style="color: rgb(153, 153, 153);line-height: 20px;">很好，到达时间快，业务员上门服务，便宜优惠</div>
                        </van-col>
                    </van-row>
                </div></van-swipe-item>
                <van-swipe-item><div class="jusaf">
                        <van-row>
                        <van-col span="4">
                            <img src="@/assets/stage/icon17.png" alt=""/> 
                        </van-col>
                        <van-col span="20">
                            <div style="color:#000;height:20px;line-height: 20px;">
                                <van-row>
                                    <van-col span="12">莹**子</van-col>
                                    <van-col span="12" style="text-align:right;color:#999;">234</van-col>
                                </van-row>
                            </div>
                            <div style="color: rgb(153, 153, 153);line-height: 20px;">好实惠的手机套餐，经济适用。</div>
                        </van-col>
                    </van-row>
                </div></van-swipe-item>
                <van-swipe-item><div class="jusaf">
                        <van-row>
                        <van-col span="4">
                            <img src="@/assets/stage/icon17.png" alt=""/> 
                        </van-col>
                        <van-col span="20">
                            <div style="color:#000;height:20px;line-height: 20px;">
                                <van-row>
                                    <van-col span="12">毛**九</van-col>
                                    <van-col span="12" style="text-align:right;color:#999;">234</van-col>
                                </van-row>
                            </div>
                            <div style="color: rgb(153, 153, 153);line-height: 20px;">网速杠杠的，费用美美的</div>
                        </van-col>
                    </van-row>
                </div></van-swipe-item>
            </van-swipe>
        </div>
        
       <div class="f_img">
            <img src="@/assets/haoka/7.jpg" alt="" style="margin-bottom:38px;width:100%;">
        </div>
       
        <div class="f-tbottm"  @click="aaaa1" >查看详情</div>
        <div class="chColor" v-if="isShow" @click="changeTab">0元申请 包邮到家</div> 

     <van-dialog v-model="showimg" title="资费详情介绍" show-cancel-button>
            <div style="height:80%;min-height:300px;max-height:460px;overflow-y: auto;">
                <img style="width:100%;height:100%" src="@/assets/cmcc.png" />
            </div>
        </van-dialog>
    </div>
</template>
  <!-- Bytedance Tracking -->
    <script>
      (function(r,d,s){r._tt_config=true;var _baq=(r._baq=r._baq||[]);_baq.methods=["track","off","on"];
      _baq.factory=function(method){return function(){var args=Array.prototype.slice.call(arguments);
      args.unshift(method);_baq.push(args);return _baq}};for(var i=0;i<_baq.methods.length;i++){
      var key=_baq.methods[i];_baq[key]=_baq.factory(key)}_baq.load=function(){
      var js,fjs=d.getElementsByTagName(s)[0];js=d.createElement(s);
      js.src="https://analytics.oceanengine.com/api/v2/js/sdk";fjs.parentNode.insertBefore(js,fjs)};
      _baq.load();if(_baq.invoked){return}_baq.invoked=true;_baq.track("pageview")})(window,document,"script");
    </script>
  <!-- End Bytedance Tracking -->
<script>
import areaListData from "@/utils/Area.js";
import { wxRequest } from '@/api/user'
import { Toast,Dialog } from 'vant';
export default {
    data(){
        return{
                   isFirst: 0,
             smsCode: '',
             smsFlag:false,
            btnTxt: '获取验证码',
            time: 3 * 60 * 60 * 1000,
            showimg:false,
            dataFrom:{
                
                agentId:'0xxtx1568132304197382144',
                oldIccid:'联通王卡59元套餐-23',
                takeNickname:'' ,
                provinceCode:'',
                cityCode:'',
                postDistrictCode:'',
                addressVisible:false,
                takePhone:'',
                phoneNum:'',
                takeAddress:'',
                changeCmccSim:'1',
                pcaAddress:'',
                idCard:''
            },
            checked:false,
            isShow:false,
            areaList:areaListData
        }
    },
     mounted() {
       // 滚动条的获取
       window.addEventListener('scroll', this.handleScrollx, true)
    },
    destroyed() { //离开这个界面之后，删除滚动事件，不然容易除bug
        window.removeEventListener('scroll', this.handleScrollx)
    },
    methods:{
        aaaa1(){
            this.showimg=true;
        },
          getSmsCode(){
              const rulut = this.$getRsaCode(this.dataFrom.takePhone) //加密
            var data = {
                userPhone: rulut
            }
            wxRequest("bindPhone/sms/code/auth", data, "post").then(res => {
                if(res.data.code == 200){
                    var n = 60;
                    this.btnTxt = '重新发送' + n +'s';
                    let timer = window.setInterval(() => {   
                        n--;                     
                        this.btnTxt = '重新发送' + n +'s';
                        if(n < 1){
                            window.clearInterval(timer);
                            this.btnTxt = '获取验证码';
                        }
                    },1000)
                   Toast.success("发送成功");
                }else{
                    Dialog.alert({title: "提示", message:res.data.message});
                }
            })
        },
        handleScrollx() {
            if(window.pageYOffset >= 600){
                this.isShow = true
            }else{
                this.isShow = false
            }
        },
        changeTab(){
            document.getElementById('formData').scrollIntoView({
                block: 'center',
                behavior: 'smooth' // 代表平滑滚动
            });
        },
        cancelSelectAddress() {
            this.dataFrom.pcaAddress = "";
            this.dataFrom.addressVisible = false;
        },
        showAddressVisible() {
            this.dataFrom.addressVisible = true;
        },
        selectAddress(values) {
            if (!values[0].code || values[0].code.length < 1) {
                Toast.fail("请选择地区");
                return;
            }

            if (!values[1].code || values[1].code.length < 1) {
                Toast.fail("请选择地区");
                return;
            }

            if (!values[2].code || values[2].code.length < 1) {
                Toast.fail("请选择地区");
                return;
            }

            if (
                values[0].code == "110000" ||
                values[0].code == "120000" ||
                values[0].code == "310000" ||
                values[0].code == "500000"
            ) {
                this.dataFrom.pcaAddress = values[0].name +'-'+ values[2].name;
            } else {
                this.dataFrom.pcaAddress = values[0].name +'-'+ values[1].name +'-'+ values[2].name;
            }
            this.dataFrom.addressVisible = false;
        },
        // 提交数据
        sunmbitFn(){
                if(!this.checked){
            Toast.fail('请勾选个人信息收集证明协议');
            return
            }
             this.dataFrom.smsCode=this.smsCode;
             wxRequest('/applyChangeSim/apply/sim/add/haoka/ex', this.dataFrom, 'post').then(res => {
                    if(res.data.code == 200){
                           _baq.track("form", { assets_id: "1736410631", product_name: '鞋子', product_price: 10 })
                        Toast.fail('提交成功，预计24时小时内发货，请耐心等待！');
                    }else {
                        Toast.fail(res.data.message);
                    }
                })
        },
                bbbb(){
            Dialog.confirm({
            title: '销售服务协议',
            width:'90%',
            showCancelButton:false,
            messageAlign:'left',
            confirmButtonColor:'#ee0a24',
            message: `中国移动广东公司电子渠道商品销售服务协议
            中国移动广东公司电子渠道商品销售服务协议
尊敬的客户，您好：
根据《中华人民共和国电信条例》及其他相关法律、法规的规定，在平等、自愿、公平、诚实、信用的基础上，为明确双方的权利和义务，规范双方业务行为，就您（下称“甲方”）与中国移动通信集团广东有限公司（下称“乙方”）电子渠道开户服务的有关事宜，达成并签定协议如下：
一、 电子渠道商品销售相关定义
1.1、乙方电子渠道包括但不限于门户网站（gd.10086.cn）、手机WAP网站（wap.gd.100086.cn），10086APP客户端、10086热线、10086短信服务厅。
1.2、电子渠道商品包括但不限于语音、短信、流量、手机、手机配件、号码卡、数据卡、路由器及其预存营销案。
1.3、商品销售订单履行，指商品订单下单后的执行过程，包括但不限于配送上门或客户自提、订单包裹交接、商品涉及的业务开通、后续话费返还，具体以乙方电子渠道公布的履行电子渠道商品销售及服务（下称“电子服务”）方式和要求为准。
二、 服务内容及承诺
2.1、甲方愿意购买乙方电子渠道相关商品，并接受乙方提供的相关电子服务；乙方愿意在现有技术条件下按照本协议的规定及其不时发布的操作规则为甲方提供电子服务，具体电子服务内容根据甲方通过乙方电子渠道购买商品或接受服务的具体内容确定。
2.2、甲方同意本协议的全部条款并按照相关提示完成全部操作以获取乙方电子服务，否则视作甲方放弃乙方提供的电子服务。
2.3、甲方在操作过程中点击或回复“同意”等相关内容即表示已详细阅读点击或回复的内容及本协议的全部条款，并完全理解并同意接受点击或回复的内容及本协议的全部条款。
2.4、乙方提供的电子服务应当符合法律法规的规定，甲方应遵守法律法规的规定使用乙方提供的电子服务。
2.5、乙方应向甲方提供便捷的业务办理和客户投诉受理渠道，乙方应在接到客户投诉后按对外承诺时间通过10086热线、电子渠道等方式予以回复。
三、 电子服务协议签定与履行
3.1、甲方按照乙方电子渠道提示选择合适商品，并需进行必要身份信息验证；甲方在下单前应清楚了解商品相关内容，成功下单后不能将不了解商品或服务作为不履行订单的理由。
3.2、甲方应在确认所选购商品后，认真阅读乙方通过电子渠道展示的本协议相关内容，同意后按乙方电子渠道的提示进行相关操作，一旦完成操作，即视为甲方完全理解和接受本协议的全部条款。
3.3、甲方应按照乙方电子渠道提示，选择合适的履行电子服务方式（包括但不限于配送上门等，具体以乙方电子渠道信息公布为准），完成相关信息的填写，并确保信息的真实性。
3.4、除不可抗力外，成功下单后双方都应按照乙方电子渠道公布的履行电子服务方式和要求完成订单履行。履行订单时，甲方需提供本人真实有效的身份证件（仅限于身份证）。
四、 费用及费用交纳
4.1、甲方购买并使用乙方提供的电子服务应支付相关费用，乙方收取的相关费用应符合法律法规的规定和相关订单的约定。
与相关网络服务有关的设备（如电脑、调制解调器及其他与接入互联网有关的装置等）及其所需的费用（如为接入互联网而支付的电话费及上网费等）均应由甲方自行负担。
4.2、甲方应按照与乙方约定的方式（包括但不限于在线支付、货到付款等），向乙方交纳订单全部费用，订单费用包括但不限于商品价格、运费及相关税费。
4.3、甲方有权要求乙方提供费用查询服务，乙方有义务就订单费用对甲方合理要求进行解释。
五、双方的权利和义务
5.1、甲方应保证其为签订本协议提供的相关资料真实、准确、有效，甲方承诺当资料发生变更后，及时按乙方业务流程通知乙方更改；若甲方提供的资料不真实或存在其它法律障碍，乙方有权随时暂停服务，并解除本协议及本协议有效期内与甲方签订的任何协议，由此造成乙方损失的，乙方将保留追究甲方赔偿乙方损失的权利。
5.2、甲方通过电子渠道成功下单，甲乙双方本次商品交易即达成，即视为甲方完全接受本协议项下的全部条款，双方应严格按照本协议及订单约定完成订单履行；非因不可抗力因素不履行或不完全履行订单的，另一方有权要求违约方赔偿违约造成的损失。
5.3、手机号码和客户密码是甲方重要个人资料和用户身份识别凭证，甲方应妥善保管，凡按照乙方业务规则使用手机号码和客户密码通过乙方电子渠道购买的商品或服务，均视为甲方亲自办理，并由甲方负责。甲方应当对以其手机号码和客户密码签权进行的所有活动承担法律责任。
5.4、乙方需通过相关合适的电子渠道向甲方提供电子服务、本协议相关内容的查询服务，甲方需按法律法规要求合理使用该查询服务，不得损害乙方权益。
5.5、甲方在使用乙方电子服务过程中，需遵循以下原则：
（1）遵守中国有关的法律和法规；
（2）不得为任何非法目的而使用乙方系统或电子服务；
（3）遵守所有与电子服务有关的协议、规定和程序；
（4）不得利用乙方系统进行任何可能对互联网的正常运转造成不利影响的行为；
（5）不得利用乙方系统发布、传输任何骚扰性的、中伤他人的、辱骂性的、恐吓性的、庸俗淫秽的或其他任何非法的信息资料；
（6）不得利用乙方电子服务系统进行任何侵害乙方合法权益的行为；
（7）如发现任何非法行为、隐患或安全漏洞的情况，应立即通告乙方。
六、协议的变更和终止
6.1、甲方依据本协议通过电子渠道购买乙方产品或服务的资费方案有效期，以下单时相关产品或服务的相关说明或约定为准（资费方案有效期默认为1年，双方特殊约定的除外）。
有效期满后，乙方如需修改资费方案及相关约定内容，应在修改前30天通过不限于短信、APP、微信、邮件、门户网站（WAP/WEB）等方式通知甲方，甲方可以选择修改后的资费方案或乙方提供的其他资费方案。若甲方不接受修改后的资费方案及乙方提供的其他资费方案，在结清全部费用后，乙方可解除本协议。
有效期期满后，乙方无需修改资费方案及相关约定内容，若双方未提出异议，原资费方案自动延期。
如遇政府主管部门统一调整资费标准，本协议按政府主管部门调整后的资费标准在规定时间起执行。
6.2、非乙方原因导致订单履行失败，则视本协议自动终止，乙方对此不承担任何法律责任；如甲方对本订单相关商品仍有需要，则需通过乙方电子渠道重新下单。
七、所有权及隐私保护
7.1、乙方提供的电子服务内容包括但不限于文字、软件、声音、图片、录像、图表，所有内容均受版权、商标和其它财产所有权等国家相关法律保护；甲方只有在获得乙方或其合法权利人的合法授权之后才能使用，而不能擅自复制、或创造与之有关的派生产品。
7.2、甲方的通信自由和通信秘密不受侵犯，乙方对甲方的客户资料和通信信息负有保密义务。但根据法律法规规定，司法、行政机关依法要求乙方提供协助和配合，乙方给予协助和配合的，不构成违反保密义务。
7.3、甲方不得利用乙方提供的服务从事违法犯罪活动或损害社会公共利益的活动，不得发送违法信息或未经接收客户同意发送骚扰信息，不得有拨打骚扰电话等不当行为，否则，乙方可以暂停向甲方提供服务，直至终止服务，由此造成的后果由甲方自行承担。
7.4、甲方同意保障和维护乙方利益，如因甲方违反有关法律法规或本协议项下的任何条款而给乙方或第三方造成损失，甲方需承担损害赔偿责任。
甲方隐私被他人非法窃取，乙方将在法律法规范围内积极配合甲方主张权利。
7.5、乙方保证不对外公开或向第三方提供甲方资料，但下列情况除外：
(1) 乙方为正常生产经营、履行订单等所必要；
（2）事先获得客户的明确授权；
（3）根据有关的法律法规要求；
（4）按照相关政府主管部门的要求；
（5）为维护社会公众的利益。
八、 重要声明
8.1、甲方在协议签定、履行等环节不按乙方操作规则和提示完成的，或乙方已经明示其电子服务发生变更并提醒甲方应当注意事项，但甲方未按要求操作，所产生的不利后果由甲方自行承担。
8.2、甲方理解并同意接受使用电子服务所存在的风险，并同意完全承担非乙方原因产生的此类风险责任。
8.3、由于电子渠道的特殊性，乙方申明不保证乙方电子渠道提供的服务不会中断，不保证乙方电子渠道提供的服务的绝对及时、安全、真实和无差错，也不保证甲方发送的信息能完全准确、及时、顺利地被传送。
8.4、如因系统维护或升级等需要而需暂停电子服务，乙方将尽可能事先在电子渠道公告，甲方或任何第三方未及时按照公告内容采取相应措施而造成损失，乙方将不承担任何责任。
8.5、对于订单履行的部分工作，乙方将在法律允许范围或参考行业做法，聘请第三方协助开展，因第三方责任造成甲方意外损失的，损失将由第三方负责赔偿，乙方将积极配合甲方主张权利。但因不可抗力等原因除外。
8.6、电子服务及本协议相关内容可通过电子渠道页面、电子邮件或短信等方式公告或传达，该类公告或传达之时即视为已送达甲方，因甲方未留意、未阅读等原因造成其损失的，乙方不承担任何责任。
8.7、如发生下列任何一种情形，乙方有权随时中断或终止向甲方提供本协议项下的服务，乙方不承担任务责任：
（1）甲方提供的资料不真实、不准确、不全面；
（2）甲方违反本协议中规定的使用规则；
（3）发生不可抗力、不可预测因素或非乙方故意或政府行为等原因导致本协议无法履行。
九、争议解决
甲方和乙方在履行本协议的过程中，如发生争议，应友好协商解决。协商不成的，任何一方均可向乙方住所地人民法院起诉。
十、 协议生效和效力
10.1、甲方通过乙方电子渠道或其他非电子渠道购买商品时签署的业务清单、表单、协议等为本协议的补充协议，与本协议冲突部分以补充协议为准，补充协议中未约定部分以本协议为准。
10.2、本协议构成双方对本协议之约定事项及其他有关事宜的完整协议，除本协议规定的之外，未赋予本协议各方其他权利。
10.3、如本协议中的任何条款无论因何种原因完全或部分无效或不具有执行力，本协议的其余条款仍应有效并且有约束力。
10.4、本协议为电子协议，保存在乙方相关电子渠道，甲方可通过相关乙方电子渠道查询；甲方在乙方电子渠道完成下单，本协议立即生效。
10.5、本协议为上一级主体协议《电子渠道登录服务协议》的子协议，以附件的形式作为主体协议的一部分。本协议的效力受《电子渠道登录服务协议》约束，对同类业务或服务的条款说明以《电子渠道登录服务协议》的相关条款内容为准。

解约条款
甲方：中国移动通信客户
乙方：中国移动通信集团广东有限公司
      甲方业务协议解约按类型分为“直接解约”和“有条件解约”两大场景。
一、直接解约
主要是涉及甲方直接订购的业务，乙方未进行任何优惠或补贴，甲方也未得从乙方得到实物或权益等相关的业务，采用无条件直接解约。
二、有条件解约
1.合约业务
如涉及赠送终端、话费存送、设备租赁或承诺在网或承诺消费获得相应优惠等业务，一般不能直接解约，甲方在“完成优惠赔付、不影响二次销售的退货”等情况下，有条件解约，按解约标准和流程操作（如有事先签订赔付标准，按约定的赔付标准执行）。具体如下：
（1）资金优惠：如话费存送、套餐折扣等。解约条件：根据优惠、减免情况支付违约金。赔付标准：甲方如提前终止协议，则甲方需将已履行月份获赠金额或优惠减免金额总额、以及未履行月份所有低消或套餐金额总额的一定比例（法律规定范围内）进行赔付。
（2）业务赠送：如承诺消费送流量包、语音包、短信包等。解约条件：根据已赠送业务价值，支付合理的违约金。赔付标准：甲方如要求提前终止协议，则甲方需将已获赠业务进行价值折算进行赔付。非流量类（语音、短信等）按单价标准资费折算，流量类按实际单价优惠资费折算。
（3）宽带业务：如网龄送宽带，承诺低消送宽带。解约条件：提前终止宽带业务需对初装费或拆机费进行赔付。赔付标准：甲方如要求提前终止协议，需根据前期活动约定的初装费用或拆机费用进行赔付。
（4）实物赠送：如承诺消费送终端、充值卡等。解约条件：在不影响二次销售的前提下，退还赠送的实物；在无法退还实物的情况下，通过对实物进行折现，支付违约金。赔付标准：根据退货要求且不影响二次销售的前提下，可在完成赠送实物退货后解约；如赠送实物已不满足退货条件，则甲方需根据实物赠送价值及未履行承诺期限进行补偿。
（5）权益赠送：如咪咕视频、爱奇艺、优酷会员权益等。解约条件：需根据活动约定退回方可解约，不能退回需按价值折算进行补偿（权益赠送协议签订中应明确约定赠送权益的价值或折算方法）。赔付标准：权益未使用可在完成赠送权益回退后解约；权益已领取、使用，则甲方需将已使用权益进行价值折算，赔偿后解约。
（6）实物租赁：如家庭宽带机顶盒、光猫等。解约条件：确保设备完好的情况下，返还租赁物；如无法归还或涉及其他利益损失的，可通过折现，支付合理违约金。赔付标准：甲方如要求提前终止协议，需根据活动约定条件退回或赔偿租赁物，根据退货约定且不影响二次销售的前提下，可在完成租赁实物退回后解约（注，如租赁物非新：在确保设备完好的情况下，可在完成租赁物退货后解约）；如租赁物已不满足再次租赁条件（设备已无法正常使用），则甲方需根据租赁设备价值进行等价偿还。
2.融合业务
融合套餐、主副卡、统付、共享、家庭网、集团网、惠农网、双向亲情互打等业务，需在不影响其他甲方业务使用的情况下，根据具体情况进行退订或解除。
类别	场景	解约条件	举例
融合业务	统付业务、主副卡等	取消统付关系、解除相关成员	家庭统付、家庭网、集团网等
	共享业务	解除共享关系	流量、语音共享等
	V网	解除V网成员关联关系	家庭网、集团网、惠农网、双向亲情互打等
注：①主卡、共享者解除，应对其他成员尽到通知义务。
②副卡、被共享者解除，不应对其他成员权益造成损失。
3.吉祥号码业务
如四连号、三连号等吉祥号码。解约条件：按吉祥号码低消和未履行协议期进行赔付。赔付标准：如甲方要求提前终止协议，则甲方应当按照未履行月份所有低消或套餐金额总额向乙方支付损失赔偿金，如甲方有签约减免或降档低消金额特殊情况的，采用前述同样标准执行。（参考最新吉祥号码等级对应的低消或套餐标准）。
4.集团信息化业务
解约条件：根据乙方投入成本补贴和未履行时间等进行价值折算赔付（协议签订中应明确约定相关业务价值或折算方法）。
赔付标准：具体赔付标准按签订的协议条款折算。


 


            `
            }).then(() => {
                // on confirm
            }).catch(() => {
                // on cancel
            });
        },
                cccc(){
            Dialog.confirm({
            title: '入网协议',
            width:'90%',
            showCancelButton:false,
            messageAlign:'left',
            confirmButtonColor:'#ee0a24',
            message: `电子渠道开户服务协议
尊敬的客户，您好！
根据《中华人民共和国电信条例》及其他相关法律、法规的规定，在平等、自愿、公平、诚实、信用的基础上，为明确双方的权利和义务，规范双方业务行为，就您（下称“甲方”）与中国移动通信集团广东有限公司（下称“乙方”）电子渠道开户服务的有关事宜，达成并签定协议如下：
一、移动通信服务的开通及服务内容
1.甲方愿意使用乙方提供的号码，或者使用甲方自其它运营商携号转网携入的号码，接受乙方提供的电信服务，乙方愿意在现有技术条件下的网络覆盖范围内以及签订有漫游协议的电信运营商的网络覆盖范围内为甲方提供服务，具体服务内容由甲乙双方通过签署业务受理单或电话、短信等其他方式另行约定。（特别提醒：甲方使用4G/5G网络服务，需更换为USIM卡、办理4G/5G套餐/产品和使用适配终端；甲方同时理解在现有技术条件下移动通信网络尚无法达到无缝隙覆盖。）
2.甲方应使用取得国家入网许可并具有进网许可标志的终端设备，该终端设备应具有支持其所选服务的相应功能。甲方因使用未取得入网许可或不具备相应功能的终端设备所产生的后果由甲方自行承担。
3.如果甲方订购第三方服务商提供的由乙方代收服务费的增值电信业务，乙方在收费前应当告知甲方即将定制的服务及收费方式并征得甲方同意。若甲方对代收的服务费有异议，由乙方、第三方服务商依据协议约定的相关原则和处理程序及时与甲方协商解决相关争议。
4.甲方依据乙方公布的各渠道鉴权方式办理业务，甲方通过乙方鉴权方式办理的业务均视为甲方或甲方授权的行为。如使用服务密码或随机验证码办理业务的行为均被视为甲方或甲方授权的行为。
5.甲方购买乙方产品或服务自订购成功并生效之日起资费方案有效期为1年，另有约定的除外。到期后若双方无异议，则自动按照当前资费方案续约。若乙方需修改资费方案及相关约定内容，应当提前30天通过短信、APP、微信、邮件、门户网站（WAP/WEB）等至少一种方式通知甲方，甲方可以选择修改后的资费方案或乙方提供的其他资费方案，若甲方不接受修改后的资费方案或乙方提供的其他资费方案，甲方应在结清全部费用后，办理相关服务终止手续。
如政府主管部门对资费等相关内容的政策发生变化，乙方将根据相关要求，对原资费方案行相应调整。调整后方案的具体执行时间以乙方公示为准。
6.根据《关于防范和打击电信网络诈骗犯罪的通告》的相关规定，乙方通过电子渠道发展新用户时，有权要求甲方办理实名登记，并采取在线视频实人认证等技术方式对甲方身份信息进行检验。
7.甲方应当自购买卡号之日起30天内完成实名认证及激活。
甲方收到该号码的实体USIM卡后，可选择实名认证及激活方式如下：（1）按照配送附带的操作指南进行自助实名认证及激活；（2）套卡客户持卡和身份证到乙方自有营业厅，在工作人员的协助下，进行现场实名认证并激活。
8.若甲方逾期未完成实名认证并激活，甲方收到号码实体USIM卡将无法激活使用，乙方有权回收甲方购买的号卡及甲方选定号码。白卡开户的系统自动退款给原购销帐户上，套卡开户的费用不作客户退款。（注：白卡开户，包括但不限于18元/24元王卡开户、38元/88元大流量开户、动感青春卡开户；套卡开户，包括但不限于万能副卡。）
二、甲方主要权利及义务
（一）主要权利
1.除双方另有约定外，甲方可以在乙方提供的资费方案范围内选择变更资费种类。
2.甲方在结清所有费用后可以将本协议项下的号码过户给第三人。办理过户手续后本协议自动终止，甲方过户后不能查询或打印过户前的账单、清单、发票。
3.甲方在结清所有费用后可以持登记的有效证件到乙方营业网点申请销户。除双方另有约定外，乙方不应拒绝甲方销户。
4.甲方在销户后可以申请退还通过银行划扣、现金方式交清费用后的余额。参与营销活动取得的话费余额按活动协议约定进行处理，未约定的，优惠赠送余额随销户失效。
5.除参与赠送、优惠等营销活动的费用余额外，甲方销户时（包括携号转网携出时）可以预约将余额一次性转入另一个在乙方开立的号码。
6.乙方为甲方提供音频或视频通知音服务，在甲方拨打电话未接通前，通过音频或视频通知音的方式将被叫号码所处状态及时告知甲方；甲方确知乙方提供的音频或视频通知音服务可能含广告信息，甲方同意接收乙方在电信服务过程中显示的相关信息；甲方若不愿意接受此类信息或服务，有权通过乙方提供的关闭功能进行关闭，或通过付费方式进行服务升级，自行选择订阅专属化音视频内容。
（二）主要义务
1.甲方应遵守法律法规的规定使用乙方提供的服务。
2.甲方使用乙方号码或自其他运营商携号转网携入的号码，并接受乙方提供的电信服务，需办理入网登记手续。甲方办理入网手续时，应当按照《电话用户真实身份信息登记规定》（工业和信息化部令第25号）向乙方出示有效身份证件进行实名制登记。甲方本人持有效身份证最多可为全国范围内5个中国移动号码进行实名制登记，甲方名下已登记中国移动号码达到5个的，乙方将根据规定拒绝甲方开通新号码的申请。甲方同意乙方影印留存甲方及其委托的受托人在办理入网登记时提供的身份证件。如甲方入网登记资料发生变更，应及时到乙方营业网点等渠道进行修订、完善。因甲方或其受托人提供的资料不详、不实或变更后未及时办理资料修订、完善手续等原因所造成的后果由甲方自行承担（以单位名开户的集团客户，使用人身份证件须与号码一一对应）。甲方因欠费销户，甲方将被限制办理乙方业务，甲方需缴清欠费后方能解除限制。
3.如果甲方选择密码保护的，入网后应立即设置服务密码并妥善保管，因甲方原因密码保管不善造成的后果由甲方自行承担。若发现号码被盗的，甲方应及时拨打客服热线10086或到乙方营业网点办理停机手续，并向公安机关报案。乙方有义务按照法律规定协助有关国家机关依据职权等调查相关情况。
4.甲方应按照与乙方约定的时间、方式，向乙方交纳费用账单中记载的全部费用。如甲方以过户方式取得号码使用权，甲方应该自行了解原号码的使用和缴费情况，若过户后存在转让人应缴未缴的费用（过户时未出账费用），由甲方承担。
5.甲方开通的号码属于：
□新号码。
□重新放号号码。甲方应自行了解该号码曾捆绑的第三方信息，包括但不限于银行、支付宝、微信、水电煤气缴费，若需更新捆绑信息甲方应自行向第三方经营者提出。
甲方同时确知乙方无从知晓且无权解除号码合法使用人与第三方服务机构之间的号码绑定约定。如甲方不再使用原号码，应当自行提前解除号码曾捆绑过的第三方信息，否则造成信息泄露或经济损失，由甲方自行承担责任，与乙方无关。甲方选择使用重新放号号码将可能需承担因此种绑定可能产生的不利后果。乙方无法预知上述可能后果。
6.甲方应当通过乙方官方营业渠道购买电话卡（电话号码），并办理实名制登记手续。甲方不得二次转售、倒卖电话卡（电话号码）。如甲方存在转售、倒卖电话卡（电话号码）等违约行为，乙方有权对甲方采取关停号码、解除合同等措施，由此造成的后果由甲方承担。
7.若甲方的号码属于吉祥号码，经甲、乙双方协商一致，甲方可以将吉祥号码过户给第三人。甲方和第三人应按照过户规则到乙方营业网点办理过户手续，在甲方结清所有费用后，由第三人按照过户时乙方关于吉祥号码的新入网政策（最新吉祥号码等级对应的首次预存话费标准、每月最低消费标准、承诺最低消费期限）与乙方重新签订吉祥号码使用协议，本协议自动终止。在办理过户手续之前，因使用吉祥号码导致的交费义务及一切后果仍由甲方承担。甲方申请过户时，首次预存话费已返还且未使用完的，由新机主享用。
三、乙方主要权利与义务
（一）主要权利
1.乙方认为甲方存在以下情形之一的，乙方有权解除本协议，终止提供服务或限制甲方新入网申请； 
（1）甲方（包括受托人）提供的证件或资料虚假不实； 
（2）利用乙方提供的服务从事违法犯罪活动，或出现违规外呼、呼叫频次异常、超约定用途使用、转租转售等违反国家监管部门相关规定的行为；
（3）利用乙方提供的服务从事损害社会公共利益或他人合法权益的活动；
（4）利用乙方提供的服务从事违背公序良俗的活动；
（5）甲方欠费满90日仍未交纳费用。
或乙方收到国家有关部门通知及其他文件要求停止向甲方提供通信服务的，乙方亦有权解除本协议且不承担任何责任。
2.乙方有权按照所欠费用自交费日期届满次日起每日加收3‰（千分之三）的违约金，并可以通过电话、信函、公告、委托第三方等方式追缴全部欠费和违约金。
3.甲方在欠费停机期间，停机当月和复机当月的月使用费（套餐费）照常计收（另有协议约定的除外）。
4.甲方销户90天后，乙方有权将甲方原号码回收后进行二次放号。
5.若甲方承诺曾承诺消费或承诺在一定期限使用约定套餐，可享受乙方提供的相关优惠。在停机期间，乙方仍有权按照相关约定向甲方收取甲方所承诺消费金额和所承诺使用套餐所必须缴纳的费用。乙方采用市场化方式合理设定吉祥号码分类等级和合约周期，为甲方提供有合同期限的、非终身保底消费方案。
6.甲方向乙方申请停机保号业务的，乙方有权依照相关规定收取停机保号费；若甲方办理主副卡相关业务的，主卡在申请停机保号同时，副卡亦进入停机保号状态，主卡和副卡均需分别支付各自的停机保号费。
7.乙方根据实际业务情况可在甲方办理的资费方案或产品的电子或实物业务受理单上标注甲方所办理业务的网络服务范围（如，2、3、4、5G网络服务），甲方所办理的相关业务将仅限于规定网络服务范围内使用规定。
8.如果甲方丧失民事主体资格，本协议自动终止，乙方有权作销户处理，收回号码，终止提供电信服务。
（二）主要义务
1.乙方提供的电信服务和收取的相关费用应当符合国家相关规定、政府主管部门发布的相关标准和甲乙双方的约定。
2.乙方通过营业厅、门户网站、10086热线、微博、微信、APP等渠道公示服务项目、服务时限、服务范围及资费标准等内容，并向甲方提供便捷的业务办理和客户投诉受理渠道。
3.欠费停机之日起90日内，甲方交清欠费和违约金的，乙方应在甲方交清欠费和违约金后的24小时内恢复服务。
4.乙方为甲方提供免费的话费查询服务，并对账单、清单进行解释。清单仅显示需要向甲方收费的业务使用记录。
乙方计费原始数据保留期限为5个月(系统产生用户话单当月起后5个月，不含当月)，甲方确知在产生原始数据后5个月内未查询的，将无法再次查询相关信息。若甲方对乙方收取的费用存有异议，应在上述计费原始数据保留期限内及时提出，上述期限内未提出的，乙方将无法对甲方异议予以原始数据复核，将以乙方现存信息为准；逾期提出的，甲方应承担由此产生的不利后果。甲方对乙方收取的费用提出异议的，乙方有责任进行调查、解释和处理。经核实确属乙方责任多收费用的，乙方应将已多收的部分按对外承诺的方式返还甲方。
5.乙方需对甲方提供发票，发票保留期限为5个月(不含当月),补打发票按税法相关规定执行。
6.乙方每月为甲方免费提供139邮箱电子账单自动推送服务，甲方如需取消服务可点击账单邮件底部“退订邮件”按钮进行退订。
7.甲方销户之日起90天内，甲方要求号码恢复使用，可凭有效证件在乙方指定的营业厅办理销户重开。
四、隐私和通信权益保护
1.甲方的通信自由和通信秘密不受侵犯。甲方在申请办理乙方相关业务时，甲方同意乙方为服务目的收集甲方相关个人信息资料，乙方对甲方的个人信息（包括但不限于客户资料和通信信息）负有保密义务。但根据法律、行政法规规定，司法、行政机关依法要求乙方提供协助和配合，乙方应给予协助和配合的，不构成违反保密义务。
2.为提供更为精准优质的服务，乙方应严格按照《网络安全法》、《全国人民代表大会常务委员会关于加强网络信息保护的决定》、《电信和互联网用户个人信息保护规定》（工业和信息化部令第24号）、《电话用户真实身份信息登记规定》（工业和信息化部令第25号）等法律法规的相关要求，在业务活动（包括但不限于业务受理系统登记、纸质返档，通过网络接收、读取并记录）中收集、使用甲方个人信息，乙方有权依法对包含甲方在内的整体用户数据进行分析并加以利用。未经甲方同意，乙方不向除乙方关联公司外的第三方提供甲方个人信息。甲方可以通过营业厅或乙方指定的其他渠道，对其个人信息进行查询、更正。为了让甲方及时了解和享受乙方推出的最新业务或优惠，甲方同意乙方可以通过电话、短信、邮件、媒体广告等方式向甲方告知或推荐使用。
3.甲方在接受和使用乙方的服务和产品前，应了解乙方的《隐私政策》（该政策已在乙方官方网站发布并可在服务厅索取），本协议签署即视为甲方已了解并同意乙方的隐私政策。
4.甲方通过乙方提供的服务发送信息、拨打电话，必须遵守国家的有关规定和行政规章制度。如甲方利用乙方提供的服务发送垃圾信息、违法信息或拨打骚扰电话，包括但不限于反动类、涉黑类、涉黄类、诈骗类、谣言类、推销类，乙方有权采取停止短信功能、停机、解除服务协议等措施，并配合公安部门追查信息来源，依法追究甲方的相关法律责任。甲方的上述行为如违反国家法律法规，乙方有权视具体情况拒绝甲方恢复通信功能的申请。
五、携号转网
1.根据工信部文件要求，携号转网服务是指在同一本地网范围内，蜂窝移动电话用户变更签约的基础电信业务经营者而用户号码保持不变的一项服务。甲方申请携号转网服务的相关权利义务说明如下：
（1）甲方有权依据国家携号转网相关的有效规定，向乙方申请携号转网。
（2）乙方根据甲方申请，为甲方办理携号转网过程中，乙方需要将必要的甲方资料提供给携号转网集中业务管理系统，以用于比对携入方和携出方登记的号码使用人身份信息是否一致。
（3）甲方办理携号转网（包括转入、转出）应符合相关条件并提供所需要的材料。甲方携号转网的条件及所需要的材料，乙方已通过营业网点、门户网站、10086热线等渠道进行公示。
（4）甲方申请号码携入乙方网络时，因不同网络技术与设备等差异，甲方可能需要更换终端。甲方启用携入新卡的时间点及网络切换期间可能会短时间影响正常通信。
（5）甲方携入乙方网络前，应当与携出方结清申请携号转网时已出账的费用，同时，甲方确认在携出方享有的积分、VIP级别、赠送话费及相关优惠权益都将无法继续使用，携出方及其合作伙伴提供的部分业务或服务将无法继续使用。
（6）甲方需及时将携号转网事宜告知社会上号码相关的服务提供者，以免携号转网后无法正常接收短信和电话等相关信息。
2.甲方向乙方申请将号码携出至其他运营商网络的，甲方在其他运营商申请办理号码携入后，乙方终止向甲方提供电信服务，甲方不再就该号码向乙方或乙方关联公司主张任何权益或优惠。
3.甲方应在完成网络切换后30日内或在收到账单后10日内向乙方结清携出时未出账的费用。甲方超过约定交费日未交足费用的，乙方有权按照所欠费用自交费日次日起每日加收3‰（千分之三）的违约金，且乙方有权将甲方欠费信息共享给甲方的携入方运营商，并委托携入方运营商向甲方代为追缴甲方所欠费用及违约金。
4.甲方携带其他运营商号码与乙方签订本协议的，乙方有权根据携出方运营商的委托，代其追缴甲方在号码携出时未结清的携出方运营商的电信费用及违约金，追缴方式包括但不限于从甲方话费账户中扣减。
5.甲方办理乙方的业务如存在在网协议期限，甲方在协议有效期内办理携号转网构成违约，甲方需按相关解约条款向乙方支付违约金（包括但不限于营销活动违约金、家庭宽带优惠补收费）。
6.甲方办理乙方业务存在优惠期或有效期的，均属于承诺在网期限，甲方在承诺在网期限内需持续使用中国移动网络。
7.甲方携带其他运营商号码携入乙方网络的，甲方入网协议自乙方提供的移动电话卡（电话号码）激活启用之日（即完成网络切换之日）起生效。
六、解约条款
1.甲方订购乙方业务，且乙方业务无任何优惠或补贴，甲方未从乙方获得实物或权益，甲方可无条件向乙方申请解约。
2.甲方办理乙方资金优惠类业务（包括但不限于话费存送、套餐折扣），甲方如要求提前终止协议，则甲方需按照已履行月份获赠金额或优惠减免金额总额、以及未履行月份所有低消或套餐金额总额的一定比例（法律规定范围内）向乙方支付违约金。
3.甲方办理乙方业务赠送类业务（包括但不限于承诺消费送流量包、语音包），甲方如要求提前终止协议，则甲方需按照已获赠业务进行价值折算向乙方支付违约金。非流量类（语音、短信等）按终止协议时市场单价资费折算，流量类按终止协议时市场单价优惠资费折算。
4.甲方办理乙方宽带类业务（包括但不限于网龄送宽带，承诺低消送宽带），甲方如要求提前终止协议，则甲方需按照前期活动约定的初装费用或拆机费用向乙方支付违约金。
5.甲方办理乙方实物赠送类业务（包括但不限于承诺消费送终端、充值卡），甲方如要求提前终止协议，甲方应当根据退货要求在不影响二次销售的前提下，将赠送实物退还至乙方后方可解约；如赠送实物已不满足退货条件，则甲方应当根据实物赠送价值及未履行承诺期限予以乙方补偿。
6.甲方办理乙方权益赠送类业务（包括但不限于咪咕视频、爱奇艺、优酷会员权益），甲方要求提前终止协议的，如甲方未使用权益，可在完成赠送权益回退后解约；如甲方已领取或使用权益，则甲方应当按照已使用权益折算后的价值向乙方支付违约金后方可解约。
7.甲方办理乙方实物租赁类业务（包括但不限于家庭宽带机顶盒、光猫、路由器），甲方如要求提前终止协议，甲方应当按照活动约定，在不影响二次销售或租赁的前提下将租赁实物退回至乙方后方可解约；如租赁实物已遗失或损坏，则甲方应当按照租赁设备价值进行等价偿还。
8.甲方办理乙方融合类业务（包括但不限于融合套餐、主副卡、统付、共享、家庭网、集团网、惠农网、双向亲情互打），甲方如要求提前终止协议，则甲方应当在不影响其他甲方业务使用的情况下，根据具体情况进行退订或解除后方可解约。甲方解除主卡、共享者之前，应当及时通知其他成员，因甲方通知不及时导致其他成员业务无法使用等后果由甲方承担。甲方解除副卡、被共享者，不应对其他成员权益造成损失。
9.甲方办理乙方吉祥号码业务（如四连号、三连号等），如甲方要求提前终止协议，则甲方应当按照未履行月份所有低消或套餐金额总额向乙方支付损失赔偿金，如甲方有签约减免或降档低消金额特殊情况的，采用前述同样标准执行。（参考最新吉祥号码等级对应的低消或套餐标准）。
10.甲方办理乙方集团信息化业务，甲方如要求提前终止协议，则甲方应当按照具体业务协议条款约定标准向乙方支付违约金后方可解约。
11. 所有涉及解约赔付需到指定的线下营业厅办理。
七、其他约定事项
1.甲方办理各类业务所签署的业务受理单、表单、协议等为本协议的补充协议，与本协议冲突部分以补充协议为准，补充协议中未约定部分适用本协议。
2.乙方有权在必要时变更本协议条款。乙方变更本协议条款的，将以包括但不限于在营业网点告示、门户网站公告、电子邮箱、手机短信通知等方式中的一种或多种，向甲方发送本协议的变更情况，甲方可以根据上述方式查阅相关的变更协议条款。本协议条款变更且乙方及时通过上述方式通知甲方后，如果甲方继续使用乙方提供的电信服务，即视为甲方已接受变更后的协议。如果甲方不接受变更后的协议，可向乙方申请销户或携号转网。
3.本协议项下发生的争议，甲乙双方应协商解决。协商不成的，双方可向乙方住所地人民法院提起诉讼。
八、特别提示
1.甲方同意乙方通过业务端口（不限于10086端口）、微博、微信和邮箱等渠道不定期向甲方发送服务提醒、关怀、升级、推荐和优惠等信息。
2.甲方通过乙方APP、微信、门户网站、充值卡等渠道充值的话费具有使用期限限制，甲方请留意充值提示界面，并及时在有效期限内使用。
3.乙方提供的来电显示、呼叫转移服务将遵照国家规范及行业标准进行，对于其他运营商（含国外运营商）传送的号码将如实显示，但乙方不保证该号码在发送端的真实性，甲方应谨防可能存在的网络违法侵权风险。甲方应采取谨慎的方式仔细甄别号码的真实性（如通过回拨等方式予以确认），谨防可能存在的网络信息诈骗及其他第三方违法侵权风险。
4.乙方根据现行的电信行业规范保障甲方的通信安全，并对甲方在乙方账户内的话费余额负有安全保障义务，对超出乙方服务范围的业务及资金安全，乙方声明不承担任何安全保障义务。甲方需对其将手机号码与金融机构、第三方支付机构及其他服务提供商进行绑定，将本号码作为甲方与第三方的鉴权方式、账号密码找回方式等可能造成甲方信息泄露、资金损失的途径的行为自行承担可能产生风险，乙方对上述将号码关联其他服务商而造成的损失不承担任何责任，因此造成的不利后果需由甲方自行承担。
5.乙方关联公司是指乙方现在或将来控制、受控制或与其处于共同控制下的任何公司、机构以及上述公司或机构的合法继承人。其中“控制”是指直接或间接地拥有影响所提及公司管理的能力，无论是通过所有权、有投票权的股份、合同或其他被人民法院认定的方式。
6.甲方或其受托人已详细阅读本协议的全部条款，特别是加粗条款，甲方或其受托人在签署本协议后即视为完全理解并同意接受本协议的全部条款。
九、协议生效和效力
1.本协议自甲方勾选“同意”按钮时或者电子签名的方式签署时生效，生效即视为甲方完全理解并同意接受本协议的全部条款，特别是加粗条款。本协议的任何条款如因任何原因而被确认无效，都不影响本协议其他条款的效力。
2.甲方名下任意一个手机号码登录电子渠道并“同意”本协议时，等同于本协议对甲方名下所有手机号码具有效力。
3.甲方“同意”本协议外，甲方在乙方线下渠道或者电子渠道办理各类业务所签署的业务受理单、表单、协议等为本协议的补充协议，与本协议冲突部分以补充协议为准，补充协议中未约定部分适用本协议。
4.本协议项下发生的争议，甲乙双方应协商解决。协商不成的，双方可向乙方住所地人民法院提起诉讼。
5.本协议有效期为1年。在有效期届满前30天，如果任何一方未向对方提出异议，有效期届满后则：
□本协议自动展期1年，展期次数不限；
□本协议终止。
个人/单位在通信企业申请通讯工具涉电信网络新型违法犯罪法律责任及防范提示告知书
 
为加强通讯工具（包括但不限于手机卡、无线上网卡、物联网卡、固话号码、宽带账号等所有通信企业的通讯工具）的规范管理，避免个人或单位在通信企业申请的通讯工具被违法犯罪人员用于实施电信网络新型违法犯罪活动，特将相关法律责任及防范提示告知如下：
—、明知他人实施电信网络诈骗犯罪，仍以出售、出租、出借、转让等方式非法提供本人（本单位）通讯工具供他人使用的，依照《关于办理电信网络诈骗等刑事案件适用法律若干问题的意见》（法发（2016）32号）第四条第三款之规定，以电信网络诈骗共同犯罪追究刑事责任。
二、个人或者单位应当妥善保管本人名下所有通讯工具，严禁以出售、出租、出借、转让等方式非法提供本人（本单位）通讯工具供他人使用。实施上述禁止行为且该通讯工具被查实用于实施电信网络诈骗等犯罪活动的，依照《中华人民共和国刑法》第二百八十七条之二规定，以帮助信息网络犯罪活动罪追究刑事责任。
三、根据《广东省防范打击电信网络诈骗不良信用通信用户惩戒办法》（粤公通〔2020〕114号）第五条之规定, 可以对电信网络诈骗不良信用通信用户名下的所有手机号码、固话号码、无线上网卡和物联网卡等通信业务一律先行全部关停，被关停后未经公安机关许可不得恢复，5年内不得为其办理通信产品新入网业务并将其个人或单位信息向社会公布
请客户将“我已清楚并知晓上述告知内容及相应法律责任，将依法申请、使用本人（本单位）通讯工具，绝不非法向他人出售、出租、出借或转让通讯工具。”内容手抄入以下划线处。
特别提示：本告知书一经签署，即视为已知悉并理解本告知书内容，承诺不参与电信网络违法犯罪行为。（请在抄写内容首尾端纳印）
                                                           
                                                             
个人签名（单位盖章）：         
身份证号：                                 年   月   日  



 


            `
            }).then(() => {
                // on confirm
            }).catch(() => {
                // on cancel
            });
        },
        aaaa(){
            Dialog.confirm({
            title: '入网协议',
            width:'90%',
            showCancelButton:false,
            messageAlign:'left',
            confirmButtonColor:'#ee0a24',
            message: `中国移动通信客户服务协议
        
甲方：中国移动通信客户
乙方：中国移动通信集团广东有限公司        分公司
一、移动通信服务内容
1.甲方愿意使用乙方提供的号码，或者使用甲方自其它运营商携号转网携入的号码，接受乙方提供的电信服务，乙方愿意在现有技术条件下的网络覆盖范围内以及签订有漫游协议的电信运营商的网络覆盖范围内为甲方提供电信服务，具体服务内容由甲乙双方通过签署业务受理单或电话、短信等其他方式另行约定。（特别提醒：甲方使用4G/5G网络服务，需更换为USIM卡、办理4G/5G套餐/产品和使用适配终端；甲方同时理解在现有技术条件下移动通信网络尚无法达到无缝隙覆盖。）
2.甲方应使用取得国家入网许可并具有进网许可标志的终端设备，该终端设备应具有支持其所选服务的相应功能。甲方因使用未取得入网许可或不具备相应功能的终端设备所产生的后果由甲方自行承担。
3.乙方根据实际业务情况可在甲方办理的资费方案或产品的电子或实物业务受理单上标注甲方所办理业务的网络服务范围（如，2、3、4、5G网络服务），甲方所办理的相关业务将仅限于规定网络服务范围内使用。

4.甲方可自由选择是否订购第三方服务商提供的由乙方代收服务费的增值电信业务（以下简称“代收费业务”）。
5.甲方依据乙方公布的各渠道鉴权方式办理业务。甲方通过乙方鉴权方式办理的业务均视为甲方或甲方授权的行为，包括但不限于如使用服务密码或随机验证码等鉴权方式办理业务的行为。
6.乙方将根据法律法规要求，免费向甲方提供中华人民共和国大陆境内火警 119、匪警110、医疗急救120、交通事故报警122等紧急电话的接入服务。
7.甲方接受乙方提供的电信服务的资费方案有效期为1年，自成功订购并生效之日起计算，双方另有约定的除外。到期后若双方无异议，则自动按照当前资费方案续约。
如政府主管部门对资费等相关内容的政策发生变化，乙方将根据相关要求，对原资费方案行相应调整。调整后方案的具体执行时间以乙方公示为准。
8.乙方通过营业厅、门户网站、10086热线、微博、微信、APP等渠道公示服务项目、服务时限、服务范围及资费标准等内容，并向甲方提供便捷的业务办理和客户投诉受理渠道。
9.乙方为甲方提供音频或视频通知音服务，在甲方拨打电话未接通前，通过音频或视频通知音的方式将被叫号码所处状态及时告知甲方；甲方确知乙方提供的音频或视频通知音服务可能含广告信息，甲方同意接收乙方在电信服务过程中显示的相关信息；甲方若不愿意接受此类信息或服务，有权通过乙方提供的关闭功能进行关闭，或通过付费方式进行服务升级，自行选择订阅专属化音视频内容。
二、入网登记
1.甲方使用乙方号码或自其他运营商携号转网携入的号码，并接受乙方提供的电信服务，需通过乙方官方营业渠道办理入网登记手续。甲方办理入网登记手续时，应当按照《电话用户真实身份信息登记规定》（工业和信息化部令第25号）向乙方出示有效身份证件进行实名制登记。甲方委托他人办理入网登记手续的，受托人应当出示甲方和受托人的有效身份证件，并提供甲方和受托人的真实身份信息。甲方及其受托人同意乙方影印留存甲方及其受托人在办理入网登记时提供的身份证件。
甲方应为或被视为完全民事行为能力人。如甲方为无民事行为能力人或限制民事行为能力人，则按相关法律法规规定处理。
甲方以其有效身份信息在全国范围内最多可办理5个中国移动号码的入网登记手续。如甲方名下已登记中国移动号码达到5个的，乙方有权拒绝甲方新入网登记手续申请。以单位名义开户的集团客户号码，需同时对应登记号码实际使用人个人身份信息。
2.甲方或其受托人拒绝出示有效身份证件提供真实身份信息的，或冒用他人的证件的，或使用伪造、变造的证件的，乙方有权不为其办理入网手续。甲方冒用他人身份证件或使用伪造、变造身份证件骗取办理入网手续的，应自行承担相关法律责任，同时乙方有权解除本协议，因此造成乙方损失的，甲方应当予以全额赔偿。
3.甲方开通的号码（不包括其他运营商携入号码）属于重新放号号码。甲方应自行了解该号码曾捆绑的第三方应用信息，包括但不限于银行、支付宝、微信、水电煤气缴费，若需更新捆绑信息甲方应自行向第三方经营者提出。甲方明确知悉乙方无从知晓且无权解除该号码此前与第三方经营者之间的号码绑定约定。
4.如甲方入网登记资料发生变更，应及时到乙方营业网点等渠道进行修改、完善。因甲方或其受托人提供的资料不详、不实或变更后未及时办理资料修改、完善手续等原因所造成的后果由甲方自行承担。
5.甲方在入网时应对服务密码进行设置或修改并妥善保管。因甲方密码设置或保管不善造成的后果由甲方自行承担。若号码被盗的，甲方应及时拨打客服热线10086或到乙方营业网点办理停机手续，并向公安机关报案。乙方有义务按照法律规定对有权国家机关进行的案件调查取证等予以协助。
为方便办理业务，乙方可根据甲方申请以短信等方式提供随机密码，该密码可作为办理业务的临时凭证。甲方认可，其使用服务密码、随机密码办理业务的行为均为甲方或甲方授权的行为。
6.甲方SIM卡丢失或毁损的，甲方可凭在乙方登记的有效身份证件到乙方营业网点办理补卡或换卡手续，或通过乙方指定的其他方式办理。甲方委托他人代办需同时提供甲方及受托人真实有效身份证件及委托书，乙方有权要求同时辅以服务密码、通话记录、缴费记录、入网时间、已开通业务等相关信息验证后进行办理。乙方可以就前述事项收取相应费用。
7.根据公安部和工业和信息化部要求，甲方如需使用乙方来电提醒、呼叫转移等基于呼叫转移实现的相关业务，应向乙方申请开通呼叫转移功能。
三、服务资费及费用交纳
1.甲方使用乙方提供的电信服务应支付相关费用，乙方收取的费用应符合法律法规的规定和双方的约定。
2.乙方每月可为甲方免费提供139邮箱等电子账单自动推送服务，甲方如需取消账单推送服务的可点击账单邮件底部“退订邮件”按钮退订。乙方应为甲方提供免费的话费查询服务，并有义务对账单、清单进行解释。乙方提供的话费查询清单仅显示要向甲方收费的业务使用记录。
3.甲方应按照约定的资费标准、时间和方式向乙方及时、足额交纳费用账单中记载的全部费用。甲方超过约定交费日未交足费用（以下称“欠费”），乙方有权暂停提供电信服务(以下称“欠费停机”)，并可以自约定交费日次日起按照所欠费用每日加收3‰（千分之三）的违约金。自欠费停机之日起90日内，如甲方交清欠费和违约金的，乙方应在甲方交清欠费和违约金后的24小时内恢复暂停的服务；欠费停机满90日，如甲方仍未交清欠费和违约金的，乙方有权解除协议和终止提供电信服务（以下简称“销号”），并可以通过信函、公告、委托第三方等方式追缴全部欠费和违约金。在甲方缴清全部历史欠费和违约金前，乙方有权拒绝与甲方订立其他电信服务协议。
4.如甲方承诺消费或承诺在一定期限使用约定套餐，可享受乙方提供的相关优惠。在套餐有效期内因甲方原因停机的，乙方仍有权按照约定向甲方收取甲方所承诺消费金额和所承诺使用套餐所必须缴纳的费用。乙方采用市场化方式合理设定吉祥号码分类等级和合约周期，为甲方提供有合同期限的、非终身保底消费方案。
5.乙方计费原始数据保留期限为5个月(系统产生用户话单当月起后5个月，不含当月)，甲方已明确知悉如需查询相关信息的，应在且只能在产生原始数据后5个月内进行查询。若甲方对乙方收取的费用存有异议，应在上述计费原始数据保留期限内及时提出，如逾期提出的，乙方将无法对甲方异议进行原始数据复核，将以乙方现存信息为准。甲方对乙方收取的费用提出异议的，乙方有责任进行调查、解释和处理。经核实确属乙方责任多收费用的，乙方应将已多收的部分按对外承诺的方式返还甲方。
6.甲方正常缴清话费后，如需开具发票的，应在话费缴清后12个月内（不含缴费月当月）向乙方要求开具；超过12个月需补开的，则按发票管理办法等规定执行。。
7.如甲方欠费停机的，在欠费停机期间，停机当月和复机当月的月使用费（套餐费）照常计收（另有协议约定的除外），欠费全停跨整月不收取月使用费（套餐费）。
8.甲方向乙方申请办理、取消停机保号业务的，办理及取消当月的号码月使用费（套餐费）照常计收，停机保号期间跨整月计收停机保号费，另有约定除外。如甲方办理了主副卡相关业务的，主卡在申请停机保号同时，副卡亦将进入停机保号状态，主卡和副卡均需分别支付各自的停机保号费。
9.如甲方向第三方服务商订购代收费业务的，则视同甲方同意乙方代第三方服务商向甲方收取服务费。该服务费的资费标准由第三方服务商制订并告知甲方。若甲方对代收的费用有异议的，应自行与第三方服务商协商解决，乙方提供必要的协助。
10.甲方应妥善保管自己的号码，如发现其号码的通信费用异常增长，应及时到乙方营业网点或乙方指定的其他渠道办理停机手续，并向公安机关报案。乙方应积极配合甲方和公安部门调查相关情况。
四、协议的变更、终止和转让
1.除双方另有约定，甲方可在乙方现行有效执行的资费方案范围内变更选择适用的资费方案。
2.如乙方需在资费方案有效期（一年）届满后，修改资费方案或相关约定内容，应当在有效期届满前30天通过短信、APP、微信、邮件、门户网站（WAP/WEB）等至少一种方式通知甲方，甲方可以选择修改后的资费方案或乙方提供的其他资费方案，若甲方不接受修改后的资费方案或乙方提供的其他资费方案，应在与乙方结清全部费用后，办理协议终止手续。
3.甲方在结清所有费用后并经乙方同意的，可以将本协议项下的号码过户给第三人。甲方和第三人应持双方有效身份证件到乙方营业网点办理过户手续，手续办理完成后本协议自动终止。号码过户后，甲方不能查询或打印过户前的账单、清单、发票。过户前发生但在过户日还未结算的该号码产生的所有费用由新机主支付。
4.若甲方过户给第三人的号码属于吉祥号码，需在甲方结清所有费用后，甲方和第三人按照过户规则到乙方营业网点办理过户手续。由第三人与乙方按照过户时乙方吉祥号码新入网政策（最新吉祥号码等级对应的首次预存话费标准、每月最低消费标准、承诺最低消费期限）签订吉祥号码客户协议，本协议自动终止。在办理过户手续之前，因使用吉祥号码导致的交费义务及一切后果仍由甲方承担。号码过户时，首次预存话费已返还且未使用完的，由过户后的新机主享用。
5.甲方在结清所有费用后可以持登记的有效身份证件到乙方营业网点办理协议解除手续（以下称“销户”）。除双方另有约定外，乙方不应拒绝甲方销户。销户后甲方应主动解除该号码捆绑的银行、理财、个人社交账号等第三方应用，如甲方未及时解除号码捆绑造成信息泄露或经济损失，乙方不承担责任。
6.甲方在销户后可以申请退还通过银行划扣、现金方式缴纳的费用余额。甲方参与乙方营销活动获得的优惠或赠送的费用余额按活动协议约定进行处理，未作约定的，则该余额随销户失效。
7.除参与营销活动获得的优惠或赠送的费用余额外，甲方销户或携号转网携出的，可以预约将余额一次性转入在乙方开立的号码（如该号码账户不属于甲方，相关后果由甲方自行承担）。
8.在甲方办理号码销户之日起90天内，如甲方申请号码恢复使用，可凭有效身份证件在乙方指定的营业厅办理销户重开；甲方办理号码销户之日起满90天，乙方有权将该号码回收进行二次放号。
9.甲方存在以下情形之一的，乙方有权解除本协议，终止提供服务或限制甲方新入网申请：
（1）甲方（包括受托人）提供的包括身份证件在内的证件、资料虚假不实或冒用他人身份证件的；
（2）利用乙方提供的服务从事违法犯罪活动，或出现未经接收方同意发送商业广告信息、发送短信或拨打电话给他人造成骚扰、违规外呼、呼叫频次异常、超约定用途使用、转借转租或转售电话卡等违反国家监管部门相关规定的行为；
（3）利用乙方提供的服务从事损害社会公共利益、他人合法权益或其他违背公序良俗的活动；
（4）甲方欠费满90日仍未缴清费用；
（5）乙方收到国家有关部门通知要求停止向甲方提供通信服务的。
10.如果甲方丧失民事主体资格，本协议自动终止，乙方有权作销户处理，收回号码，终止提供电信服务。
11.甲方在SIM卡丢失后应当及时向乙方申请停机，因甲方未及时申请停机而造成的后果，由甲方自行承担。
五、携号转网
1.携号转网服务是指在同一本地网范围内，蜂窝移动电话用户(不含物联网用户)变更签约的基础电信业务经营者而用户号码保持不变的一项服务。甲方申请携号转网服务的相关权利义务约定如下：
（1）甲方有权依据国家携号转网相关的有效规定，向乙方申请携号转网；
（2）乙方根据甲方申请，为甲方办理携号转网过程中，将必需的甲方资料提供给携号转网集中业务管理系统，以用于比对携入方和携出方登记的号码使用人身份信息是否一致；
（3）甲方办理携号转网（包括转入、转出）应符合相关条件并提供所需要的材料。甲方携号转网的条件及所需要的材料，乙方通过营业网点、门户网站、10086热线等渠道进行公示；
（4）甲方申请号码携入乙方网络时，因不同网络技术与设备等差异，甲方可能需要更换终端。甲方启用携入新卡的时间点及网络切换期间可能会短时间影响正常通信；
（5）甲方携入乙方网络前，应当与携出方结清申请携号转网时已出账的费用，同时，甲方确认在携出方享有的积分、VIP级别、赠送话费及相关优惠权益都将无法继续使用，携出方及其合作伙伴提供的部分业务或服务将无法继续使用；
（6）甲方应及时将携号转网事宜通知号码绑定的第三方业务经营者，避免号码在携号转网后无法正常接收第三方业务经营者的电话或短信等情形。
2.甲方向乙方申请将号码携出至其他运营商网络的，甲方在其他运营商申请办理号码携入后，乙方终止向甲方提供电信服务。甲方无权就该号码向乙方或乙方关联公司主张任何权益或优惠。
3.甲方向乙方申请将号码携出至其他运营商网络的，应在完成网络切换后30日内或在收到账单后10日内向乙方结清携出时未出账的费用。甲方超过约定交费日未交足费用的，乙方有权自约定交费日次日起按照所欠费用每日加收3‰（千分之三）的违约金，且有权将甲方欠费信息共享给甲方的携入方运营商，并委托携入方运营商向甲方代为追缴甲方所欠费用及违约金。
4.甲方携入其他运营商号码与乙方签订本协议的，乙方有权根据携出方运营商的委托，代其追缴甲方在号码携出时未结清的携出方运营商的电信费用及违约金，追缴方式包括但不限于从甲方话费账户中扣减。
5.如甲方与乙方之间存在在网期限约定或承诺的，甲方在在网期限内办理携号转网构成违约，需按相关约定向乙方支付违约金（包括但不限于营销活动违约金、家庭宽带优惠补收费）后方可申请携号转网。
6.甲方办理乙方业务时如有约定优惠期或有效期的，均属于承诺在网期限，甲方在承诺在网期限内不申请携号转网或在承担违约责任后方可申请携号转网。
六、隐私、个人信息和通信权益保护
1.甲方的通信自由和通信秘密不受侵犯。甲方在申请办理乙方相关业务时，甲方同意乙方为服务目的收集甲方相关个人信息资料，乙方对甲方的个人信息（包括但不限于客户资料和通信信息）负有保密义务。但根据法律、行政法规规定，司法、行政机关依法要求乙方提供协助和配合，乙方应给予协助和配合的，不构成违反保密义务。同时，甲方应理解并知悉，甲方有义务保护自身个人隐私和个人信息安全。甲方在乙方营业网点或其他渠道办理业务时，应在了解业务规则、资费等详细信息后，自行获取并输入密码或随机验证码（如需要）。甲方充分知悉，如果他人（含乙方工作人员）代替甲方操作，则此类行为会带来各类严重风险，包括但不限于信息泄露、信息被滥用以及隐私被侵犯等。
2.个人信息是指以电子或者其他方式记录的与已识别或者可识别的自然人有关的各种信息，不包括匿名化处理后的信息。敏感个人信息是一旦泄露或者非法使用，容易导致自然人的人格尊严受到侵害或者人身、财产安全受到危害的个人信息，包括生物识别、宗教信仰、特定身份、医疗健康、金融账户、行踪轨迹等信息，以及不满十四周岁未成年人的个人信息。乙方收集、使用甲方个人信息，应当遵循合法、正当、必要的原则。针对甲方敏感个人信息，乙方将采取更加严格的保护措施保障个人信息处理安全，包括但不限于开展个人信息保护影响评估、在实现目的所需的最小必要范围内处理敏感个人信息、采取加密等安全技术措施、在处理敏感个人信息前获得甲方单独同意并通知甲方等（本协议以下将对涉及到的敏感个人信息以粗体进行显著标识）。
3.甲方理解并同意，乙方可以通过业务受理系统登记、纸质返档，通过网络接收、读取并记录等方式，以提供电信服务所必需为目的，在业务活动中限于实现处理目的的最小范围内收集、使用甲方提供的和甲方使用服务过程中形成的个人信息。乙方基于提供电信服务所收集和使用甲方个人信息的具体内容如下：
3.1办理入网手续
基于为甲方办理入网手续的目的，乙方会收集甲方的【姓名、证件类型、证件号码、证件有效期、个人面部信息、住址信息】；
3.2业务受理、提供与计费
基于受理甲方电信业务订购需求，保障甲方正常使用电信服务及实现业务计费收费准确的目的，乙方会收集甲方的【业务订购信息、消费信息、业务使用信息、个人通信设备信息、位置信息】；
3.3 优化网络服务质量
基于优化提升为甲方所提供的电信服务质量的目的，乙方会收集使用甲方的【住址信息、位置信息、通信记录信息】；
3.4 提供客户服务
为帮助甲方解决问题或记录相关问题的处理方案及结果，乙方会收集甲方的【沟通记录、订单信息、甲方提供的咨询所需的必要信息】。
为了解甲方使用乙方电信服务的感知体验，优化乙方服务内容和流程的目的，乙方可能会使用甲方【手机号码】，向甲方发送服务调研问卷，并收集甲方的【反馈信息】。甲方如不希望收到此类调研问卷，可以通过调研短信中提供的退订途径申请退订。
3.5 提供网络安全保障
为履行保障电信网络安全的法定义务，乙方可能收集和使用依法收集甲方的【个人身份信息、通信记录信息】
3.6 个性化推荐商品和服务信息
甲方知悉并同意：为向甲方展示商品或服务信息，满足甲方的多元化需求，乙方会结合依法收集的甲方的个人信息，通过算法模型预测甲方的偏好特征，并基于甲方的偏好特征，向甲方推荐甲方可能感兴趣的产品和服务（同时也将会为甲方提供不针对其个人特征的产品或服务），或者向甲方发送商业性短信息。
如甲方希望取消或退订上述个性化推荐功能，可通过以下方式取消：【10086热线、短信退订、门户网站、营业网点】。
4.乙方将会依据法律法规的要求对甲方的个人信息进行匿名化处理，并对无法识别到甲方特定个人且不能复原的整体用户数据进行统计、分析并加以利用。
5.乙方在中华人民共和国境内收集的甲方个人信息，将存储在中华人民共和国境内，并且仅会在实现收集甲方个人信息的目的所必需的最短时间内保留甲方的个人信息。超出个人信息保存期限后，乙方会对个人信息进行删除或匿名化处理，但法律、行政法规另有规定的情形除外。
6.基于为甲方提供电信服务所必需，乙方可能委托授权合作伙伴处理甲方的个人信息。乙方仅会出于本协议约定的合法、正当、必要、特定、明确的目的委托授权合作伙伴处理甲方的信息，授权合作伙伴只能接触到其履行职责所需信息。乙方会与受委托处理个人信息的授权合作伙伴约定委托处理的目的、期限、处理方式、个人信息的种类、保护措施以及各方权利和义务等，要求授权合作伙伴按照国家规定的保密和安全措施、双方约定以及乙方的要求处理甲方的个人信息。乙方与授权合作伙伴的委托关系不生效、无效、被撤销或者终止的，授权合作伙伴会将个人信息返还给乙方或者予以删除。乙方会对授权合作伙伴的上述个人信息处理活动进行监督。
7.乙方不会与任何第三方公司、组织和个人共享甲方的个人信息，但以下情况除外：
（1）事先获得甲方单独同意或授权；
（2）为履行乙方法定义务所必需的共享；
（3）基于履行与甲方订立的电信服务合同、为甲方提供电信服务所必需，将甲方个人信息与乙方关联公司或合作伙伴共享。乙方只会共享必要的个人信息，且受本协议中声明的目的的约束，乙方关联公司或合作伙伴如要改变个人信息的处理目的，需再次征求甲方的授权同意；
（4）基于符合法律法规的社会公共利益、应对突发公共卫生事件或者紧急情况下为保护自然人的生命健康和财产安全而共享。
8.甲方可以通过乙方营业厅或指定的其他渠道（包括10086电话、营业网点、门户网站等），在符合法律规定的情形及条件下，对其个人信息进行查询、复制、请求转移、更正、补充、删除、获取个人信息副本、限制和拒绝乙方处理。
9.为了让甲方及时了解和享受乙方推出的最新业务或优惠，甲方同意乙方可以通过电话、短信、邮件、媒体广告等方式向甲方告知或推荐使用。
10.甲方通过乙方提供的服务发送信息、拨打电话，必须遵守国家的有关规定和行政规章制度。如甲方利用乙方提供的服务发送垃圾信息、违法信息或拨打骚扰电话，包括但不限于反动类、涉黑类、涉黄类、诈骗类、谣言类、推销类，乙方有权采取停止短信功能、停机、解除服务协议等措施，并配合公安部门追查信息来源，依法追究甲方的相关法律责任。甲方的上述行为如违反国家法律法规，乙方有权视具体情况拒绝甲方恢复通信功能的申请。
11.甲方在接受和使用乙方的服务和产品前，应了解乙方的《隐私和信息保护政策》（该政策已在乙方官方网站发布并可在服务厅索取），本协议签署即视为甲方已了解并同意乙方的隐私和信息保护政策。
七、合同解除
1.甲方订购乙方业务，且乙方业务无任何优惠或补贴，甲方未从乙方获得实物或权益，甲方可向乙方要求解除协议。
2.甲方办理了乙方资金优惠类业务（包括但不限于话费存送、套餐折扣），如甲方要求提前终止协议，则需按照已履行月份获赠金额或优惠减免金额总额、以及未履行月份所有低消或套餐金额总额的一定比例（法律规定范围内）向乙方支付违约金。
3.甲方办理了乙方业务赠送类业务（包括但不限于承诺消费送流量包、语音包），如甲方要求提前终止协议，则甲方需按照已获赠业务进行价值折算向乙方支付违约金。非流量类（语音、短信等）按协议终止时市场单价资费折算，流量类按协议终止时市场单价优惠资费折算。
4.甲方办理了乙方宽带类业务（包括但不限于网龄送宽带，承诺低消送宽带），如甲方要求提前终止协议，则需按照约定的初装费用或拆机费用向乙方支付违约金。
5.甲方办理了乙方实物赠送类业务（包括但不限于承诺消费送终端、充值卡），如甲方要求提前终止协议，则应当根据法律规定在不影响二次销售的前提下，将赠送实物返还乙方后方可终止；如赠送实物已不满足退货条件，则甲方应当根据实物赠送价值及未履行承诺期限予以乙方赔偿。
6.甲方办理了乙方权益赠送类业务（包括但不限于咪咕视频、爱奇艺、优酷会员权益），要求提前终止协议的，如甲方未使用所赠送权益，可在完成赠送权益回退后终止；如甲方已领取或使用权益，则应当按照已使用权益折算后的价值向乙方支付违约金后方可终止。
7.甲方办理了乙方实物租赁类业务（包括但不限于家庭宽带机顶盒、光猫、路由器），如甲方要求提前终止协议，应当按照约定，在不影响二次销售或租赁的前提下将租赁实物返还乙方后方可终止；如租赁实物已遗失或损坏，则甲方应当按照租赁设备价值进行等价赔偿。
8.甲方办理了乙方融合类业务（包括但不限于融合套餐、主副卡、统付、共享、家庭网、集团网、惠农网、双向亲情互打），如甲方要求提前终止协议，则应当在不影响其他甲方业务使用的情况下，根据具体情况进行退订或解除后方可终止。甲方解除主卡、共享者之前，应当及时通知其他成员，因甲方通知不及时导致其他成员业务无法使用等后果由甲方承担。甲方解除副卡、被共享者，不应对其他成员权益造成损失。
9.甲方办理乙方吉祥号码业务，如甲方要求提前终止协议，则甲方应当按照未履行月份所有低消或套餐金额总额向乙方支付违约金，如甲方有签约减免或降档低消金额特殊情况的，采用前述同样标准执行（按照乙方最新吉祥号码等级对应的低消或套餐标准）。
10.甲方办理了乙方集团信息化业务，如甲方要求提前终止协议，则应当按照具体业务协议条款约定向乙方支付违约金后方可终止。
11.上述协议终止事项所有涉及违约金支付的需到乙方指定的线下营业厅办理。
八、其他约定事项
1.甲方办理各类业务所签署的业务受理单、表单、协议等为本协议的补充协议，与本协议约定不一致部分以补充协议为准，补充协议中未约定的适用本协议。
2.乙方有权在必要时变更本协议条款。乙方变更本协议条款的，将以包括但不限于在营业网点告示、门户网站公告、电子邮箱、手机短信通知等方式中的一种或多种，向甲方发送本协议的变更情况，甲方可以根据上述方式查阅相关的变更协议条款。本协议条款变更且乙方及时通过上述方式通知甲方后，如果甲方继续使用乙方提供的电信服务，即视为甲方已接受变更后的协议。如果甲方不接受变更后的协议，可向乙方申请销户或携号转网。
3.本协议经甲方盖章或签字后以及加盖乙方业务专用章后生效。但在甲方携带其他运营商号码使用乙方电信服务的情况下，本协议经双方盖章或签字后并自乙方提供的移动电话卡（电话号码）激活启用之日（即完成网络切换之日）起生效。本协议项下发生的争议，双方应协商解决。协商不成的，任何一方可向乙方住所地人民法院提起诉讼。
4.中国移动权益超市新星会员是面向全网用户开放的会员产品，资费为0元每月，长期有效。您可通过中国移动APP等入口登录权益超市，享受权益超市新星会员权益优惠购、福利社等权益。其中：会员优惠购指权益超市商品定价设置有会员价，会员价低于标准售价，新星会员享受以优惠的会员价购买货架商品；会员福利社是权益超市用户福利模块，新星会员用户每月可在会员福利社领取各类免费的优惠券；智能客服权益指用户可直接咨询在线客服解决问题。具体会员权益内容以中国移动权益超市会员页面展示为准。基于市场与业务的发展，中国移动有权对新星会员全部或部分权益进行更新、修改和调整。中国移动将就前述权益调整在相应的服务页面进行通知或公告，客户可以通过中国移动权益超市页面查询最新会员权益内容，并按照变更后的实际情况决定是否继续使用。如客户不再需要该服务，可通过中国移动APP等入口登录权益超市页面-我的订单处进行退订。”

特别提示：
1.甲方同意乙方通过业务端口（不限于10086端口）、微博、微信和邮箱等渠道不定期向甲方发送服务提醒、关怀、升级、推荐和优惠等信息。
2.甲方通过乙方APP、微信、门户网站、充值卡等渠道充值的话费具有使用期限限制，甲方请留意充值提示界面，并及时在有效期限内使用。
3.乙方提供的来电显示、呼叫转移服务将遵照国家规范及行业标准进行，对于其他运营商（含国外运营商）传送的号码将如实显示，但乙方不保证该号码在发送端的真实性，甲方应谨防可能存在的网络违法侵权风险。甲方应采取谨慎的方式仔细甄别号码的真实性（如通过回拨等方式予以确认），谨防可能存在的网络信息诈骗及其他第三方违法侵权风险。
4.乙方根据现行的电信行业规范保障甲方的通信安全，并对甲方在乙方账户内的话费余额负有安全保障义务，对超出乙方服务范围的业务及资金安全，乙方声明不承担任何安全保障义务。甲方需对其将手机号码与金融机构、第三方支付机构及其他服务提供商进行绑定，将本号码作为甲方与第三方的鉴权方式、账号密码找回方式等可能造成甲方信息泄露、资金损失的途径的行为自行承担可能产生风险。乙方对上述将号码关联其他服务商而造成的损失不承担任何责任，因此造成的不利后果需由甲方自行承担。
5.乙方关联公司是指乙方现在或将来控制、受控制或与其处于共同控制下的任何公司、机构以及上述公司或机构的合法继承人。其中“控制”是指直接或间接地拥有影响所提及公司管理的能力，无论是通过所有权、有投票权的股份、合同或其他被人民法院认定的方式。
6.甲方或其受托人已详细阅读本协议的全部条款，特别是加粗条款，甲方或其受托人在签署本协议后即视为完全理解并同意接受本协议的全部条款。
7.甲方理解，在现有技术条件下乙方网络及特定网络技术（如第五代移动通信技术）尚无法达到无缝隙覆盖。即使在乙方网络覆盖范围内，甲方使用的终端、SIM卡类型、所订购的服务均可能影响甲方对乙方特定网络的接入和使用。甲方如需使用特定网络，可能需要更换适配终端、SIM卡并订购相应的服务，且上述网络的质量和速率也受到多种因素的影响，包括但不限于网络技术、网络容量、甲方终端设备、甲方所订购服务情况、周边环境与天气等。
8.因不可抗力而使本协议部分或全部不能履行，双方互不承担违约责任。
9.因技术进步、国家政策变动等原因，导致本协议部分或全部无法继续履行时，乙方有权变更或终止本协议部分或全部，但应当提前发布公告，提供合理解决方案。
10.本协议有效期为1年。如在有效期届满前30天，任何一方未向对方提出异议，有效期届满后本协议自动展期1年，展期次数不限。

 
甲方（签名或单位盖章）：

监护人/受托人（签名或盖章）：

甲方号码：                         

签署日期：   年     月     日
乙方（签名或单位盖章）：

经办人（签名）：



签署日期：    年   月  日
 


            `
            }).then(() => {
                // on confirm
            }).catch(() => {
                // on cancel
            });
        },
    }
}
</script>
<style lang="less" scoped>

    .f_img{
        text-align: center;
    }
    .chColor{
        width: 90%;
        height: 44px;
        color: #fff;
        text-align: center;
        line-height: 44px;
        border-radius: 24.5px;
        font-size: 23px;
        position: fixed;
        bottom: 50px;
        z-index: 100;
        left: 0;
        margin-left: 5%;
        background: -webkit-linear-gradient(to right,#FEAC37,#FD7324); /* Safari 5.1-6.0 */
        background: -o-linear-gradient(to right,#FEAC37,#FD7324); /* Opera 11.1-12.0 */
        background: -moz-linear-gradient(to right,#FEAC37,#FD7324); /* Firefox 3.6-15 */
        background: linear-gradient(to right,#FEAC37,#FD7324); /* 标准语法 */
        border:1px solid #FD7324;
        border-image: -webkit-linear-gradient(to right,#FEAC37,#FD7324); /* Safari 5.1-6.0 */
        border-image: -o-linear-gradient(to right,#FEAC37,#FD7324); /* Opera 11.1-12.0 */
        border-image: -moz-linear-gradient(to right,#FEAC37,#FD7324); /* Firefox 3.6-15 */
        border-image: linear-gradient(to right,#FEAC37,#FD7324); /* 标准语法 */
    }
    .chColor{
        -webkit-animation: free_download1 1s linear alternate infinite;
        animation: free_download1 1s linear alternate infinite;
    }
    @-webkit-keyframes free_download1{
        0%{-webkit-transform:scale(0.9);}
        100%{-webkit-transform:scale(1);}
    }
    @keyframes free_download1{
        0%{transform:scale(0.9);}
        100%{transform:scale(1);}
    }
    .from_data{
        margin:0 14px;
        background: #fff;
        padding:9px;
        border-radius: 10px;
        .f_data{
            border-radius: 10px;
            border:1px dashed #FD7C27;
            .f_title{
                height:42px;
                line-height:42px;
                width:208px;
                background: url(../../../assets/title.png) no-repeat center;
                background-size:100% 100%;
                font-size:20px;
                color:#fff;
                text-align:center;
                margin: -21px auto 0 auto;
            }
            .my-swipe{
                height: 35px; 
                line-height:35px;
                background: #787B81;
                border-radius:6px;
                width:82%;
                margin:13px auto;
                color: #fff;
                padding:0 12px;
                span{
                    display: inline-block;
                    padding-left:16px;
                }
            }
            .checkbox-info{
                width: 85%;
                margin: 10px auto;
                font-size:12px;
                .van-checkbox{
                    display: inline-block;
                    margin-top: 4px;
                }
            }
            .btnButton{
                width:93%;
                margin: 10px auto;
                display: block;
                background: -webkit-linear-gradient(to right,#FEAC37,#FD7324); /* Safari 5.1-6.0 */
                background: -o-linear-gradient(to right,#FEAC37,#FD7324); /* Opera 11.1-12.0 */
                background: -moz-linear-gradient(to right,#FEAC37,#FD7324); /* Firefox 3.6-15 */
                background: linear-gradient(to right,#FEAC37,#FD7324); /* 标准语法 */
                border:1px solid #FD7324;
                border-image: -webkit-linear-gradient(to right,#FEAC37,#FD7324); /* Safari 5.1-6.0 */
                border-image: -o-linear-gradient(to right,#FEAC37,#FD7324); /* Opera 11.1-12.0 */
                border-image: -moz-linear-gradient(to right,#FEAC37,#FD7324); /* Firefox 3.6-15 */
                border-image: linear-gradient(to right,#FEAC37,#FD7324); /* 标准语法 */
                cursor: pointer;
                font-size:18px;
            }
            .btnButton{
                -webkit-animation: free_download 1s linear alternate infinite;
                animation: free_download 1s linear alternate infinite;
            }
            @-webkit-keyframes free_download{
                0%{-webkit-transform:scale(0.9);}
                100%{-webkit-transform:scale(1);}
            }
            @keyframes free_download{
                0%{transform:scale(0.9);}
                100%{transform:scale(1);}
            }
        }
    }
    .f-swige{
        margin:10px 14px;
        background: #fff;
        padding:9px;
        border-radius: 10px;
        height:250px;
        overflow: hidden;
        .f_new{
            font-size: 18px;
            padding:14px 0 15px 12px;
            font-weight: 600;
        }
        .jusaf{
            img{
                width:52px;
                height:52px;
            }
        }
    }
    .f-tbottm{
        width:100%;
        margin-top: 17px;
        padding-bottom: 26px;
        text-align:center;
        font-size:16px;
        cursor: pointer;
        color:#fff;
    }
</style>